import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { ReleaseNotesResponse } from '@/modules/release-notes/types';

export const getReleaseNotes = async (
  { rootState, state, commit }: SafeAny,
  { viewAll, before }: { viewAll?: boolean; before?: string } = {}
) => {
  const url = `${rootState.env.requestUrl.events}/release-notes`;

  state.releaseNotes.isLoading = true;
  state.releaseNotes.error = undefined;

  try {
    const { data } = await axiosInstance.get<ReleaseNotesResponse>(url, {
      params: {
        viewAll: viewAll || undefined,
        before
      }
    });

    state.releaseNotes.data =
      viewAll && before
        ? [...(state.releaseNotes.data ?? []), ...data.releaseNotes]
        : data.releaseNotes;
    state.truncated = data.truncated;
  } catch (error: SafeAny) {
    state.releaseNotes.error = error.message;

    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetReleaseNotes',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  } finally {
    state.releaseNotes.isLoading = false;
  }
};
